export default function subscribeToMailchimp(email) {
  return new Promise((resolve, reject) => {
    const callbackName = `jsonp_callback_${Date.now()}`
    const script = document.createElement("script")

    window[callbackName] = data => {
      delete window[callbackName]
      document.body.removeChild(script)

      if (data.result === "success") {
        resolve(data)
      } else {
        reject(data.msg)
      }
    }

    script.src = `${
      process.env.GATSBY_MAILCHIMP_ENDPOINT
    }&EMAIL=${encodeURIComponent(email)}&c=${callbackName}`

    document.body.appendChild(script)
  })
}
